import React from "react";

/**
 * @component DollarCheckmarkIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <DollarCheckmarkIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const DollarCheckmarkIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="DollarCheckmarkIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M12 2c5.523 0 10 4.477 10 10h-2a8 8 0 10-8 8v2C6.477 22 2 17.523 2 12S6.477 2 12 2zm9.607 13.707a1 1 0 010 1.414l-3.657 3.657a1 1 0 01-1.414 0l-1.829-1.828a1 1 0 011.414-1.414l1.12 1.12 2.951-2.949a1 1 0 011.415 0zM13 7v1h2v2h-4v1h3a1 1 0 01.993.883L15 12v3a1 1 0 01-.883.993L14 16h-1v1h-2v-1H9v-2h4v-1h-3a1 1 0 01-.993-.883L9 12V9a1 1 0 01.883-.993L10 8h1V7h2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
DollarCheckmarkIcon.displayName = "DollarCheckmarkIcon";
export default DollarCheckmarkIcon;
